<template>
    <div :class="classes">
        <div class="meta">
            <div class="context">
                <slot name="context"></slot>
            </div>
            <div class="actions">
                <slot name="actions"></slot>
            </div>
        </div>
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    // ForumPostBlock: a blockquote-like element that typically houses links to
    // parent posts (within reply posts) or links to answer posts (within the
    // original thread post).

    const themeToClass = {
        'normal': 'theme-normal',
        'success': 'theme-success',
    };

    export default {
        props: {
            theme: {
                type: String,
                default: 'normal',
                validator: value => {
                    return value in themeToClass;
                },
            },
        },

        computed: {
            classes() {
                return {
                    'forum-post-block': true,
                    [themeToClass[this.theme]]: true,
                };
            },
        },
    }
</script>

<style lang="scss" scoped>
    .forum-post-block {
        padding: 15px;
    }

    .meta {
        display: flex;

        .context {
            flex: 1;
        }
    }

    .theme-normal {
        border-left: 5px solid #444;
        background-color: #2d2d2d;
    }

    .theme-success {
        border-left: 5px solid #3ac384;
        //background-color: #264433;
        background-color: #2d2d2d;
    }
</style>



// WEBPACK FOOTER //
// post-block.vue?61a81180